import _classCallCheck from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Base, WordArray } from './core.js';
import { MD5Algo } from './md5.js';
/**
 * This key derivation function is meant to conform with EVP_BytesToKey.
 * www.openssl.org/docs/crypto/EVP_BytesToKey.html
 */

export var EvpKDFAlgo = /*#__PURE__*/function (_Base) {
  _inherits(EvpKDFAlgo, _Base);

  var _super = _createSuper(EvpKDFAlgo);

  /**
   * Initializes a newly created key derivation function.
   *
   * @param {Object} cfg (Optional) The configuration options to use for the derivation.
   *
   * @example
   *
   *     const kdf = CryptoJS.algo.EvpKDF.create();
   *     const kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
   *     const kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
   */
  function EvpKDFAlgo(cfg) {
    var _this;

    _classCallCheck(this, EvpKDFAlgo);

    _this = _super.call(this);
    /**
     * Configuration options.
     *
     * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
     * @property {Hasher} hasher The hash algorithm to use. Default: MD5
     * @property {number} iterations The number of iterations to perform. Default: 1
     */

    _this.cfg = Object.assign(new Base(), {
      keySize: 128 / 32,
      hasher: MD5Algo,
      iterations: 1
    }, cfg);
    return _this;
  }
  /**
   * Derives a key from a password.
   *
   * @param {WordArray|string} password The password.
   * @param {WordArray|string} salt A salt.
   *
   * @return {WordArray} The derived key.
   *
   * @example
   *
   *     const key = kdf.compute(password, salt);
   */


  _createClass(EvpKDFAlgo, [{
    key: "compute",
    value: function compute(password, salt) {
      var block; // Shortcut

      var cfg = this.cfg; // Init hasher

      var hasher = cfg.hasher.create(); // Initial values

      var derivedKey = WordArray.create(); // Shortcuts

      var derivedKeyWords = derivedKey.words;
      var keySize = cfg.keySize,
          iterations = cfg.iterations; // Generate key

      while (derivedKeyWords.length < keySize) {
        if (block) {
          hasher.update(block);
        }

        block = hasher.update(password).finalize(salt);
        hasher.reset(); // Iterations

        for (var i = 1; i < iterations; i += 1) {
          block = hasher.finalize(block);
          hasher.reset();
        }

        derivedKey.concat(block);
      }

      derivedKey.sigBytes = keySize * 4;
      return derivedKey;
    }
  }]);

  return EvpKDFAlgo;
}(Base);
/**
 * Derives a key from a password.
 *
 * @param {WordArray|string} password The password.
 * @param {WordArray|string} salt A salt.
 * @param {Object} cfg (Optional) The configuration options to use for this computation.
 *
 * @return {WordArray} The derived key.
 *
 * @static
 *
 * @example
 *
 *     var key = CryptoJS.EvpKDF(password, salt);
 *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
 *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
 */

export var EvpKDF = function EvpKDF(password, salt, cfg) {
  return EvpKDFAlgo.create(cfg).compute(password, salt);
};